export enum ModuleEnum {
  Dashboard = "Dashboard",
  Role = "Role",
  User = "User",
  Module = "Module",
  Workflow = "Workflow",
  Lookup = "Lookup",
  Setting = "Setting",
  Audit = "Audit",
  Registration = "Registration",
  Admission = "Admission",
  Maternity = "Maternity",
  VitalSign = "VitalSign",
  Diagnosis = "Diognosis",
  Laboratory = "Laboratory",
  Pharmacy = "Pharmacy",
}
export enum AppActionEnum {
  Create = "Create",
  View = "View",
  Update = "Update",
  Delete = "Delete",
  Confirm = "Confirm",
  Attest = "Attest",
  Approve = "Approve",
  Query = "Query",
  Reject = "Reject",
}
